import { useMemo } from 'react';

import {
  useLDClient,
  type LDFlagSet,
  useFlags,
} from 'launchdarkly-react-client-sdk';

const storedProps = new Map<string, any>();

const EMPTY_FLAGS: LDFlagSet = {};

export function useLDFlags() {
  const ldClient = useLDClient();
  const initialFlags = useFlags() ?? EMPTY_FLAGS;
  const allFlags = ldClient?.allFlags() ?? EMPTY_FLAGS;
  const noClientReady = useMemo(() => {
    if (!ldClient) {
      return true;
    }
    const flagCount = Object.keys(allFlags).length;
    return flagCount === 0;
  }, [ldClient, allFlags]);

  const flags = useMemo(() => {
    if (noClientReady) {
      return EMPTY_FLAGS;
    }

    return new Proxy(allFlags, {
      get(target, prop) {
        if (
          typeof prop !== 'symbol' &&
          Object.prototype.hasOwnProperty.call(target, prop)
        ) {
          if (!storedProps.has(prop)) {
            storedProps.set(prop, target[prop]);
            return ldClient.variation(prop, target[prop]);
          }
          return target[prop];
        } else {
          return undefined;
        }
      },
    });
  }, [noClientReady, allFlags, ldClient]);

  return noClientReady ? initialFlags : (flags as LDFlagSet);
}
